import * as React from "react";
import {
  Container,
  Header,
  Left,
  Button,
  Body,
  Title,
  Content,
  Form,
  Label,
  Item,
  Input,
  Picker,
  Textarea,
  Text,
} from "native-base";
import {
  View,
  Alert,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import { formatNumber } from "accounting-js";
import Icon from "react-native-vector-icons/FontAwesome";
import { currentLanguage } from "../../../translations/CurrentLanguage";

import NumberKeys from "@components/NumberKeysComponent";
import Printer from "@components/PrinterComponent";
import SearchableDropdown from "../../../stories/components/SearchableDropdownComponent";
import AddCustomer from "../../../stories/components/AddCustomerModalComponent";
let MoneyCurrency = require("money-currencies");
import translation from "../../../translations/translation";
import LocalizedStrings from "react-native-localization";
let strings = new LocalizedStrings(translation);

const PAYMENT_TYPES = ["Cash", "Card", "Visa", "Amex", "Sapn", "Wallet"];

const PAYMENT_ITEMS = [
  <Picker.Item label={strings.Cash} value="Cash" />,
  <Picker.Item label={strings.Card} value="Card" />,
  <Picker.Item label="Visa" value="Visa" />,
  <Picker.Item label="Amex" value="Amex" />,
  <Picker.Item label="Sapn" value="Sapn" />,
  <Picker.Item label="Wallet" value="Wallet" />,
];

export default class Payment extends React.PureComponent {
  onValueChange = text => {
    this.props.onValueChange(text);
  };
  payment_type = () => {
    const { paymentTypes } = this.props;
    let payment_types_values = "";
    for (let i = 0; i < paymentTypes.length; i += 1) {
      payment_types_values +=
        paymentTypes[i].type + " - " + paymentTypes[i].amount.toString() + "\n";
    }
    return payment_types_values;
  };
  onPay = () => {
    Alert.alert(
      strings.ConfirmPayment,
      strings.AreYouSure,
      [
        { text: strings.Cancel },
        { text: strings.Proceed, onPress: this.props.onPay },
      ],
      { cancelable: false },
    );
  };

  renderCustomer = () => {
    const { useDefaultCustomer } = this.props;

    if (useDefaultCustomer) {
      return null;
    }
    strings.setLanguage(currentLanguage().companyLanguage);
    return (
      <View>
        <Label style={styles.viewLabel}>{strings.Customer}</Label>
        <SearchableDropdown
          searchedCustomers={this.props.searchedCustomers}
          searchCustomer={this.props.searchCustomer}
          modalVisibleChange={this.props.modalVisibleChange}
        />
        <AddCustomer
          values={this.props.values}
          modalVisible={this.props.values.modalVisible}
          onChangeCustomerName={this.props.onChangeCustomerName}
          onChangeCustomerEmail={this.props.onChangeCustomerEmail}
          onChangeCustomerPhoneNumber={this.props.onChangeCustomerPhoneNumber}
          onChangeCustomerNotes={this.props.onChangeCustomerNotes}
          onSaveCustomer={this.props.onSaveCustomer}
          onCancelAddCustomer={this.props.onCancelAddCustomer}
        />
      </View>
    );
  };

  render() {
    strings.setLanguage(currentLanguage().companyLanguage);

    let mc = new MoneyCurrency(
      this.props.currency ? this.props.currency : "PHP",
    );
    const amountValue = this.props.settings_state.multipleMop
      ? parseFloat(this.props.payment_amount_multiple)
      : parseFloat(this.props.paymentValue);

    const amountDue = parseFloat(this.props.amountDue);

    let change = 0;

    if (amountValue - amountDue > 0) {
      change = amountValue - amountDue;
    }

    return (
      <Container style={styles.screen}>
        <Header style={styles.header}>
          <Left>
            <Button transparent onPress={this.props.navigation}>
              <Icon name="arrow-left" style={styles.headerArrow} />
            </Button>
          </Left>
          <Body>
            <Title style={styles.headerTitle}>{strings.Payment}</Title>
          </Body>
        </Header>
        <View style={styles.columns}>
          <View style={styles.contentLeft}>
            <ScrollView contentContainerStyle={styles.leftView}>
              {this.props.settings_state.multipleMop ? (
                <View style={styles.optionView}>
                  <Button transparent onPress={this.props.removeMop}>
                    <Icon name="close" style={styles.leftIcon} />
                  </Button>
                  <View style={{ flex: 1, width: "30%" }}>
                    <Picker
                      mode="dropdown"
                      selectedValue={this.props.values.selected}
                      onValueChange={this.props.onChangePayment}
                    >
                      {PAYMENT_ITEMS}
                    </Picker>
                  </View>

                  <Button transparent onPress={this.props.addMultipleMop}>
                    <Icon name="arrow-right" style={styles.rightArrow} />
                  </Button>
                </View>
              ) : null}
              <NumberKeys
                paymentType={this.props.values.selected}
                scanned_nfc={this.props.scanned_nfc}
                isCurrencyDisabled={this.props.isCurrencyDisabled}
                currency={this.props.currency}
                onPay={this.onPay}
                value={this.props.paymentValue}
                onChangeNumberKeyClick={this.onValueChange}
                mop={this.props.values.selected}
                multipleMop={this.props.settings_state.multipleMop}
              />
            </ScrollView>
          </View>
          <View style={styles.contentRight}>
            <Content padder>
              <Form style={styles.contentForm}>
                <View style={styles.summary}>
                  <View style={styles.summaryCard}>
                    <Text style={styles.summaryLabel}>{strings.AmountDue}</Text>
                    <Text style={styles.summaryValue} numberOfLines={1}>
                      {this.props.isCurrencyDisabled
                        ? formatNumber(this.props.amountDue)
                        : mc.moneyFormat(formatNumber(this.props.amountDue))}
                    </Text>
                  </View>
                  <View style={[styles.summaryCard, styles.summaryChange]}>
                    <Text style={styles.summaryLabel}>
                      {strings.AmountChange}
                    </Text>
                    <Text
                      style={[styles.summaryValue, styles.summaryChangeValue]}
                      numberOfLines={1}
                    >
                      {this.props.isCurrencyDisabled
                        ? formatNumber(change)
                        : mc.moneyFormat(formatNumber(change))}
                    </Text>
                  </View>
                </View>
                {/*{this.renderCustomer()}*/}
                <View style={styles.options}>
                  {this.props.settings_state.multipleMop ? (
                    <View style={styles.paymentView}>
                      <Label>Payment Breakdown</Label>
                      <Textarea
                        editable={false}
                        style={{
                          borderColor: "#cfcfcf",
                          borderWidth: 1,
                          whiteSpace: "pre-wrap",
                        }}
                        rowSpan={5}
                        value={this.payment_type()}
                      />

                      <Label style={styles.viewLabel}>
                        Balance{" "}
                        <Text style={{ fontSize: 11 }}>
                          (Amount Due - Total Breakdown)
                        </Text>
                      </Label>
                      <Item regular>
                        <Input
                          editable={false}
                          keyboardType="numeric"
                          value={
                            this.props.isCurrencyDisabled
                              ? formatNumber(this.props.balance) > 0
                                ? formatNumber(this.props.balance)
                                : formatNumber(0)
                              : formatNumber(this.props.balance) > 0
                                ? mc.moneyFormat(
                                    formatNumber(this.props.balance),
                                  )
                                : mc.moneyFormat(formatNumber(0))
                          }
                        />
                      </Item>
                    </View>
                  ) : (
                    <View style={styles.paymentView}>
                      <Text style={styles.sectionLabel}>
                        {strings.PaymentType}
                      </Text>
                      <View style={styles.types}>
                        {PAYMENT_TYPES.map(type => {
                          const selected = this.props.values.selected === type;
                          return (
                            <TouchableOpacity
                              key={type}
                              activeOpacity={0.8}
                              onPress={() => this.props.onChangePayment(type)}
                              style={[
                                styles.type,
                                selected ? styles.typeSelected : null,
                              ]}
                            >
                              <Text
                                style={[
                                  styles.typeText,
                                  selected ? styles.typeTextSelected : null,
                                ]}
                              >
                                {type === "Cash"
                                  ? strings.Cash
                                  : type === "Card"
                                    ? strings.Card
                                    : type}
                              </Text>
                            </TouchableOpacity>
                          );
                        })}
                      </View>
                    </View>
                  )}
                  <Printer
                    connectionStatus={this.props.values.connectionStatus}
                    connectDevice={this.props.connectDevice}
                    connection={this.props.values.connection}
                    onPrinterPress={this.props.onPrinterPress}
                    style={styles.printerStyle}
                  />
                </View>
                {this.props.values.selected === "Wallet" ? (
                  "customer" in this.props.scanned_nfc ? (
                    <View>
                      <View>
                        <Label>Customers Pin</Label>
                        <Item regular>
                          <Input
                            secureTextEntry={true}
                            editable={false}
                            keyboardType="numeric"
                            value={this.props.customers_pin_value}
                          />
                        </Item>
                      </View>
                      <View style={{ flexDirection: "row" }}>
                        <Button
                          style={styles.button}
                          onPress={this.props.proceedToWalletTransaction}
                        >
                          <Text>Proceed Wallet Transaction</Text>
                        </Button>
                        <Button
                          style={styles.button1}
                          onPress={this.props.clearCustomersPin}
                        >
                          <Text>Clear</Text>
                        </Button>
                      </View>
                    </View>
                  ) : null
                ) : null}
              </Form>
            </Content>
          </View>
        </View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    backgroundColor: "#14213d",
  },
  headerArrow: {
    fontSize: 24,
    color: "white",
  },
  button: {
    marginTop: 5,
  },
  button1: {
    marginTop: 5,
    marginLeft: 10,
  },
  rightArrow: {
    fontSize: 24,
    color: "blue",
  },
  leftIcon: {
    fontSize: 24,
    color: "red",
  },
  headerTitle: {
    fontWeight: "bold",
  },
  screen: {
    backgroundColor: "#f3f5f9",
  },
  columns: {
    flex: 1,
    flexDirection: "row",
  },
  contentLeft: {
    width: "38%",
    minWidth: 340,
    maxWidth: 520,
  },
  leftView: {
    flexGrow: 1,
    justifyContent: "center",
    padding: 24,
  },
  contentRight: {
    flex: 1,
    backgroundColor: "white",
    borderLeftWidth: 1,
    borderLeftColor: "#e3e8ef",
  },
  contentForm: {
    margin: 14,
  },
  summary: {
    flexDirection: "row",
    marginBottom: 8,
  },
  summaryCard: {
    flex: 1,
    paddingVertical: 18,
    paddingHorizontal: 20,
    borderRadius: 14,
    backgroundColor: "#f3f5f9",
  },
  summaryChange: {
    marginLeft: 14,
    backgroundColor: "#ecfdf3",
  },
  summaryLabel: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#64748b",
  },
  summaryValue: {
    marginTop: 6,
    fontSize: 30,
    fontWeight: "bold",
    color: "#0f172a",
  },
  summaryChangeValue: {
    color: "#16a34a",
  },
  sectionLabel: {
    marginBottom: 8,
    fontSize: 13,
    fontWeight: "bold",
    color: "#64748b",
  },
  types: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  type: {
    height: 46,
    minWidth: 84,
    paddingHorizontal: 18,
    marginRight: 8,
    marginBottom: 8,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#e3e8ef",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
  },
  typeSelected: {
    borderColor: "#2563eb",
    backgroundColor: "#2563eb",
  },
  typeText: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#334155",
  },
  typeTextSelected: {
    color: "#fff",
  },
  formView: {
    marginBottom: 15,
  },
  viewLabel: {
    marginBottom: 5,
  },
  optionView: {
    flexDirection: "row",
    marginTop: 15,
  },
  options: {
    marginTop: 18,
  },
  paymentView: {
    marginBottom: 14,
  },
  printerStyle: {
    maxWidth: 360,
    marginBottom: 15,
  },
});
